export default __webpack_public_path__ + "static/media/body-section-adductors.77c3e12b.png";